import { Box, IconButton, Tooltip, Typography } from '@mui/material'
import { OptionListProps } from './types'
import { CustomPaper } from '../../../../../../components/CustomPaper';
import { Images } from '../../../../../../components';
import { icons } from '../../../../../../utils/icons';
import { useStyles } from './styles';
import { useTranslation } from 'react-i18next';
import { memo } from 'react';
import NotOption from '../../../../../../assets/images/optionGroup.png'

const ListOptionGroup = ({ options, deleteOption, editOption }: OptionListProps) => {

    const styles = useStyles()
    const { t } = useTranslation()

    return (
        <Box sx={styles.container}>
            {options.length ? options.map((option) => (
                <CustomPaper key={option.id} elevation={3} sx={styles.item}>
                    {option.icon ? <Images src={typeof option.icon === 'string' ? option.icon : URL.createObjectURL(option.icon)} alt={option.description} sx={styles.images} /> : <Box sx={styles.images} />}


                    <Typography sx={styles.text}>{option.description}</Typography>

                    <Box sx={styles.iconsContainer}>
                        <Tooltip title={t('ToolTips.edit')}>
                            <IconButton onClick={() => { editOption({ description: option.description, icon: option.icon, id: option.id }) }}>{icons('edit')}</IconButton>
                        </Tooltip>
                        <Tooltip title={t('ToolTips.delete')}>
                            <IconButton onClick={() => { deleteOption(option.id) }}>{icons('delete')}</IconButton>
                        </Tooltip>
                    </Box>
                </CustomPaper>
            )) :
                <Box sx={styles.containerNoCategories}>
                    <Images sx={styles.img} src={NotOption} />
                    <Typography >{t("optionGroup.title.noOptionsAddes")}</Typography>
                </Box>
            }
        </Box>
    )
}

export default memo(ListOptionGroup)
